import * as React from 'react'

import { useGlobalSearch } from '../../providers/GlobalSearchProvider'

const SHORTCUT_LABEL_MACOS = '⌘K'
const SHORTCUT_LABEL_WINDOWS = 'Ctrl+K'

const MACOS_PATTERN = /Macintosh/i

export type UseGlobalSearchTriggerResult = {
  buttonRef: React.RefObject<HTMLButtonElement>
  shortcutLabel: string
  onClick: () => void
}

export const useGlobalSearchTrigger = (): UseGlobalSearchTriggerResult => {
  const { open } = useGlobalSearch()

  const buttonRef = React.useRef<HTMLButtonElement>(null)

  const isMacOS = MACOS_PATTERN.test(navigator.userAgent)

  return {
    buttonRef,
    shortcutLabel: isMacOS ? SHORTCUT_LABEL_MACOS : SHORTCUT_LABEL_WINDOWS,
    onClick: open,
  }
}
